<script lang="ts">
	// Svelte hooks
	import { onMount } from 'svelte';
	// Stores
	import { profile_data } from 'src/stores/account/user';
	// Services
	import { format } from 'svelte-i18n';
	// Helpers
	import { getImages } from '../../Lists/list-helpers';
	import { save_profile } from '../../../helpers/profile_helpers';
	import { getAppBackgroundSrc } from '../../../helpers/account_helpers';
	import { getBackgroundColorPreviewImages } from '../../../helpers/background_color_helpers';
	import { getFormatedValue } from '@Shelly/shelly-design-system/TimePicker/time-picker-helpers';
	// Components
	import ImageList from '../../Lists/ImageListV2.svelte';

	const requestType = 'home_background';

	const imagesByTypeDB = Array.from({ length: 10 }, (_, i) => {
		const value = getFormatedValue(i + 1);
		return {
			local: true,
			filepath: `images/home_def/app_bg_${value}.png`,
			thumb: `images/home_def/app_bg_${value}_thumb.png`,
		};
	});

	let uploadedImagesDB = [
		{
			local: false,
		},
	];

	// Image List Functions
	const onSelectImage = (e: CustomEvent) => {
		const profileDataLayout = $profile_data.layout || {};

		if (e.detail.backgroundColor) {
			// Save color and clear image
			save_profile('layout', {
				backgroundColor: e.detail.backgroundColor,
				appBackgroud: '',
			});

			profile_data.set({
				...$profile_data,
				layout: {
					...profileDataLayout,
					backgroundColor: e.detail.backgroundColor,
					appBackgroud: '',
				},
			});
		} else if (e.detail.image) {
			// Save image and clear color
			save_profile('layout', {
				appBackgroud: e.detail.image,
				backgroundColor: '',
			});

			profile_data.set({
				...$profile_data,
				layout: {
					...profileDataLayout,
					appBackgroud: e.detail.image,
					backgroundColor: '',
				},
			});
		}
	};

	const onUploadImage = (e: CustomEvent) => {
		onSelectImage(e);
	};

	const onDeleteImage = (e: CustomEvent) => {
		onSelectImage(e);
	};

	const updateHomeData = (appBackgroudSrc: string) => {
		const profileDataLayout = $profile_data.layout || {};

		// SAVE HOME SETTINGS
		save_profile('layout', {
			appBackgroud: appBackgroudSrc,
		});

		profile_data.set({
			...$profile_data,
			layout: {
				...profileDataLayout,
				appBackgroud: appBackgroudSrc,
			},
		});
	};

	onMount(async () => {
		uploadedImagesDB = await getImages(requestType);
	});
</script>

<ImageList
	groupTitle={{
		upload: $format('image_list_title_picture_custom', {
			default: 'Custom Picture',
		}),
		type: $format('gallery_bg_title', { default: 'Gallery Backgrounds' }),
	}}
	{requestType}
	{uploadedImagesDB}
	{imagesByTypeDB}
	selectedImage={getAppBackgroundSrc($profile_data)}
	selectedBackgroundColor={$profile_data?.layout?.backgroundColor || ''}
	showColors={true}
	backgroundColorPreviewImages={getBackgroundColorPreviewImages()}
	on:select-image={onSelectImage}
	on:upload-image={onUploadImage}
	on:delete-image={onDeleteImage}
	uploadSettings={{
		single: true,
		imageUploadSettings: {
			type: 'button',
			useV2Components: true,
			btnSettings: {
				title:
					uploadedImagesDB.length === 0
						? $format('upload_image_title', { default: 'Upload Image' })
						: $format('change_image_title', { default: 'Change Image' }),
				variant: uploadedImagesDB.length === 0 ? 'primary' : 'secondary',
			},
		},
	}}
	uploadImageAlert={{
		type: 'info',
		heading: $format('image_alert', {
			default: 'Recommended dimension is 1440 by 1440 pixels, size limit 2000 kb max.',
		}),
	}}
	defaultType="edit"
	imgGroupType="preview"
/>
<!-- remove key bg_img_info_msg -->
